export default __webpack_public_path__ + "static/media/send.c9edef01.svg";